/**
 * Browsers change the value of a focused number input when the mouse wheel is
 * turned over it. In an amount field that silently alters contract sums and
 * payments (a company changed a stage amount this way without noticing).
 *
 * Installed once at start-up: a wheel turn over the focused number input
 * blurs it instead, so the value stays and the page scrolls as expected. The
 * arrow keys still step the value on purpose.
 */
export function installNumberInputWheelGuard(target: Document = document): () => void {
  const onWheel = (event: WheelEvent) => {
    const active = target.activeElement;
    if (
      active instanceof HTMLInputElement &&
      active.type === 'number' &&
      event.target === active
    ) {
      active.blur();
    }
  };
  target.addEventListener('wheel', onWheel, { passive: true, capture: true });
  return () => target.removeEventListener('wheel', onWheel, { capture: true });
}
